var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var ToolboxSearch = function () {
	this.$sokLi = $( document.querySelectorAll( '#toolbox-menu li.search, .search-pane' ) );
	this.$searchInput = $( document.getElementsByClassName( 'toolbox-search-input' ) );
	this.$ajaxResults = $( document.getElementsByClassName( 'ajax-results' ) );
};

ToolboxSearch.prototype.init = function () {

	var self = this,
		dummy = self.$searchInput.val();

	var clear_search = function () {

		self.$searchInput.click( function () {

			if ( $( this ).val() === dummy ) {
				$( this ).val( '' );
			}

		} );

	};

	var ajax_search = function () {

		var data = {
				action: 'big_ajax_search',
				ajax_nonce: big_ajax.ajax_nonce,
				query: ''
			},
			i = 0;

		$( document )
			.on( 'submit', '#toolbox-search, #mobile-search', function () {

				var field = this;

				$( field ).addClass( 'loading' );
				self.$searchInput = $( field ).find( '.toolbox-search-input' );

				data.query = self.$searchInput.val();
				self.$searchInput;

				if ( data.query === dummy ) {
					return;
				}

				self.$ajaxResults.html( '' );

				// Keep the li open unless the user clicks outside of it, then hide it and clear the search.
				stick_search();

				$.post( big_ajax.url, data, function ( response ) {

					if ( response.success ) {
						self.$ajaxResults.empty().append( response.data );
						$( field ).removeClass( 'loading' );
					} else {
						console.log( 'Error grabbing AJAX search results' );
						console.log( response );
					}

				} ).fail( function ( xhr, textStatus, e ) {

					console.log( 'Error grabbing AJAX search results' );
					console.log( xhr.responseText );

				} );

				return false;

			} )
			.on( 'keypress', '.toolbox-search-input', function () {

				i ++;
				if ( i === 1 ) {
					stick_search();
				}

				if ( i < 3 ) {
					return;
				}

				$.post(
					big_ajax.url, {
						action: 'big_ajax_incremental_suggest',
						query: self.$searchInput.val()
					},
					function ( response ) {

						if ( response.success ) {
							console.log( response.data );
						} else {
							console.log( 'Error grabbing AJAX search results' );
							console.log( response );
						}

					} ).fail( function ( xhr, textStatus, e ) {

					console.log( 'Error grabbing AJAX search results' );
					console.log( xhr.responseText );

				} );
			} );
	};

	var stick_search = function () {

		self.$sokLi.addClass( 'open' );

		$( document ).mouseup( function ( e ) {

			if ( ! self.$sokLi.is( e.target ) && self.$sokLi.has( e.target ).length === 0 ) {
				self.$sokLi.removeClass( 'open' );
				self.$ajaxResults.html( '' );

				if( $(window).width() > 1000 ) {
					self.$searchInput.val( dummy );
				}
			}

		} );

	};

	ajax_search();
	clear_search();
};

module.exports = new ToolboxSearch();
